import React from 'react';
import CryptoQuoteMetrics from './CryptoQuoteMetrics';
import ETFQuoteMetrics from './ETFQuoteMetrics';
import QuoteMetrics from './QuoteMetrics';
import { BaseQuoteProfile, QuoteFund } from '../../utils/quote/types';
import { CoinData } from '@benzinga/crypto-manager';
import { Financials } from '@benzinga/securities-manager';
import { ShortInterest } from '@benzinga/quotes-manager';
import { QuoteTechnicals } from '../../../src/entities/quoteEntity';

const CallToActionForm = React.lazy(() =>
  import('@benzinga/forms-ui').then(module => {
    return { default: module.CallToActionForm };
  }),
);

interface MetricsSidebarProps {
  isETF: boolean;
  isCrypto: boolean;
  profile: BaseQuoteProfile;
  etfFund: QuoteFund | null;
  fundamentals: Financials | null;
  technicals: QuoteTechnicals;
  shortInterest: ShortInterest[] | null;
}

export const MetricsSidebar: React.FC<MetricsSidebarProps> = ({
  isCrypto,
  isETF,
  profile,
  etfFund,
  fundamentals,
  technicals,
  shortInterest,
}) => {
  return isCrypto ? (
    <CryptoQuoteMetrics profile={profile} />
  ) : isETF ? (
    <ETFQuoteMetrics etfFund={etfFund ?? null} profile={profile} />
  ) : (
    <QuoteMetrics
      fundamentals={fundamentals}
      profile={profile}
      shortInterest={shortInterest}
      technicals={technicals}
    />
  );
};
